module.exports = __webpack_public_path__ + "3b191ca24fa57de5562e33c3ef776150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/onepage_slide_pipilotti_3.jpg
// module id = 113
// module chunks = 0